import { useState } from "react";

//lib
import { Field, useFormikContext } from "formik";

//component
import Row from "./row";
import Col from "./col";
import Container from "./container";

export default function Input(props) {
  const {
    as,
    value,
    name,
    type,
    label,
    disabled,
    className,
    maxLength,
    placeholder,
    onChange,
    invalid = true,
    readOnly,
  } = props;

  const formik = useFormikContext();

  // const [inputFocus, setInputFocus] = useState(false);

  // const handleFocus = () => {
  //   setInputFocus(true);
  // };

  // const handleBlur = () => {
  //   setInputFocus(false);
  // };

  return (
    <Container className="w-100">
      <Col
        className={`element _input ${className ? className : ""}`}
        // style={
        //   inputFocus && errors && errors[name]
        //     ? { border: "0.2rem solid #ff5c5c6b" }
        //     : inputFocus
        //     ? { border: "0.2rem solid #cfcfcf" }
        //     : {}
        // }
      >
        {label && (
          <Row>
            <label>{label}</label>
          </Row>
        )}
        <Row>
          {as ? (
            as === "textarea" ? (
              <textarea
                // onBlur={handleBlur}
                // onFocus={handleFocus}
                name={name}
                disabled={disabled}
                placeholder={placeholder}
                type={type ? type : "text"}
                onChange={
                  onChange
                    ? onChange
                    : name
                    ? (e) => formik?.setFieldValue(name, e.target.value)
                    : undefined
                }
                maxLength={maxLength ? maxLength : ""}
              />
            ) : (
              <Field
                // onBlur={handleBlur}
                // onFocus={handleFocus}
                name={name}
                as={as}
                disabled={disabled}
                placeholder={placeholder}
                type={type ? type : "text"}
                onChange={
                  onChange
                    ? onChange
                    : name
                    ? (e) => formik?.setFieldValue(name, e.target.value)
                    : undefined
                }
                maxLength={maxLength ? maxLength : ""}
              />
            )
          ) : name ? (
            <Field
              // onBlur={handleBlur}
              // onFocus={handleFocus}
              name={name}
              as={as}
              disabled={disabled}
              placeholder={placeholder}
              type={type ? type : "text"}
              readOnly={readOnly}
              onChange={
                onChange
                  ? onChange
                  : name
                  ? (e) => formik?.setFieldValue(name, e.target.value)
                  : undefined
              }
              maxLength={maxLength ? maxLength : ""}
            />
          ) : (
            <input
              as={as}
              value={value}
              disabled={disabled}
              placeholder={placeholder}
              type={type ? type : "text"}
              onChange={onChange ? onChange : undefined}
              maxLength={maxLength ? maxLength : ""}
            />
          )}
        </Row>
      </Col>
      {invalid && formik?.errors && formik?.errors[name] ? (
        <Row className="element _errors">{formik.errors[name]}</Row>
      ) : null}
    </Container>
  );
}
